import { Text } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const Title = styled(Text)`
  color: ${({ color = 'gray' }: { color?: 'black' | 'gray' }) =>
    color === 'gray' ? 'var(--chakra-colors-gray-table)' : 'var(--chakra-colors-gray-primary)'};
  font-weight: bold;
`;
